import { Dispatch, SetStateAction, useMemo } from 'react';
import { Modal } from '../../../modal';
import { ContactAgentFormPostErrorResponse } from './contact-agent';
import { iconClose, iconSend, iconUser } from '../../../util/icons';

export interface ContactAgentFullFormProps {
  address: string;
  message: string;
  name: string,
  phone: string,
  email: string,
  workingWithRealtor: string;
  errorResponse: ContactAgentFormPostErrorResponse | null;
  setMessage: Dispatch<SetStateAction<string>>;
  setName: Dispatch<SetStateAction<string>>;
  setPhone: Dispatch<SetStateAction<string>>;
  setEmail: Dispatch<SetStateAction<string>>;
  setWorkingWithRealtor: Dispatch<SetStateAction<string>>;
  onSubmit(event: React.FormEvent<HTMLFormElement>): void;
  close(): void;
}

export const ContactAgentFullForm = (props: ContactAgentFullFormProps) => {

  const errorTitle = useMemo(() =>
    props.errorResponse === null ? null : <div className="alert-fail">{props.errorResponse.title}</div>
    , [props.errorResponse]);

  return (
    <Modal close={props.close} title="Contact Agent">
      <h1>{iconUser} Contact a real estate agent to discuss {props.address}</h1>
      <p>Please complete the following information to immediately contact a real estate agent who can assist you with any questions you have and assistance you require including making offers on {props.address} or any other property.</p>
      {errorTitle}
      <form name="data-collection" className="data-collection-form" onSubmit={props.onSubmit}>
        <div className="form-fieldset-horizontal">
          <div>
            <div className="form-field">
              <label>Name <span className="form-field-error">{props.errorResponse?.fields.listingcontactagentname}</span></label>
              <div className="form-field-input-div"><input name="name" type="text" value={props.name} onChange={e => props.setName(e.target.value)} /></div>
            </div>
            <div className="form-field">
              <label>Phone <span className="form-field-error">{props.errorResponse?.fields.listingcontactagentphone}</span></label>
              <div className="form-field-input-div"><input name="phone" type="text" value={props.phone} onChange={e => props.setPhone(e.target.value)} /></div>
            </div>
            <div className="form-field">
              <label>Email <span className="form-field-error">{props.errorResponse?.fields.listingcontactagentemail}</span></label>
              <div className="form-field-input-div"><input name="email" type="text" value={props.email} onChange={e => props.setEmail(e.target.value)} /></div>
            </div>
            <div className="form-field">
              <label>Are you currently working with a Realtor&reg;? <span className="form-field-error">{props.errorResponse?.fields.listingcontactagentworkingwithrealtor}</span></label>
              <div className="form-radio-fieldset">
                <div className="form-radio-field"><input name="workingWithRealtor" type="radio" value={'No'} onChange={e => props.setWorkingWithRealtor(e.target.value)} />No</div>
                <div className="form-radio-field"><input name="workingWithRealtor" type="radio" value={'Yes'} onChange={e => props.setWorkingWithRealtor(e.target.value)} />Yes</div>
              </div>
            </div>
          </div>
          <div className="form-field">
            <label>Message <span className="form-field-error">{props.errorResponse?.fields.listingcontactagentmessage}</span></label>
            <textarea className="textarea-85-height" name="message" value={props.message} onChange={e => props.setMessage(e.target.value)} />
          </div>
        </div>
        <div className="modal-footer">
          <div className="button-row">
            <button type="button" className="button-cancel" onClick={props.close}>{iconClose} Cancel</button>
            <button type="submit" className="button-confirm">{iconSend} Send Message</button>
          </div>
        </div>
      </form>
    </Modal>
  );
}
